import {Component, OnInit} from '@angular/core';
import {TranslationService} from './modules/i18n';
// language list
import {locale as enLang} from './modules/i18n/vocabs/en';
import {locale as ruLang} from './modules/i18n/vocabs/ru';
import {GeneralSettingsService} from "./api-services/general-settings/general-settings.service";

@Component({
  // tslint:disable-next-line:component-selector
  selector: 'body[root]',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
  // changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AppComponent implements OnInit {
  constructor(private translationService: TranslationService, private generalSettingsService: GeneralSettingsService) {
    // register translations
    this.translationService.loadTranslations(
      enLang,
      ruLang,
    );
  }

  ngOnInit() {
    this.generalSettingsService.getGeneralSettings().subscribe(response => {
      if (response) {
        this.generalSettingsService.setGeneralSettings(response);
      }
    });
  }
}
